export default {
	title: "Web3",
	rule: "Regler förklaring",
	safe: "Kapitalskydd",
	balance: {
		totle: "Totalt belopp",
		yesterday: "Igårs avkastning",
		cumulatively: "Kumulativ avkastning",
		in: "Insättning",
		out: "Uttag",
		available: "Tillgänglig saldo"
	},
	actions: {
		in: "Insättning",
		out: "Uttag"
	},
	type: ["Alla", "Insättning", "Uttag", "Avkastning"],
	TransactionPassword: "Transaktionslösenord",
	Amount: "Summa",
	date: "Datum"
};
